import { render, staticRenderFns } from "./AsideTools.vue?vue&type=template&id=01b1f388&scoped=true&"
import script from "./AsideTools.vue?vue&type=script&lang=js&"
export * from "./AsideTools.vue?vue&type=script&lang=js&"
import style0 from "./AsideTools.vue?vue&type=style&index=0&id=01b1f388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1f388",
  null
  
)

export default component.exports